import React from 'react';
import './Principal.css';
import useReveal from '../hooks/useReveal';
import { principal } from '../data/schoolData';
import principalPoto from '../assets/images/prinipal.jpg';

export default function Principal() {
  const cardRef = useReveal();
  const msgRef  = useReveal();
  return (
    <section className="section principal-section" id="principal">
      <div className="container">
        <div className="reveal" style={{ marginBottom: 40 }} ref={useReveal()}>
          <span className="stag">Leadership</span>
          <h2 className="stitle">Principal's Message</h2>
          <div className="sline" />
        </div>
        <div className="principal-grid">
          <div className="pc-card reveal" ref={cardRef}>
            <div className="pc-img">
              <img src={principalPoto} alt="Principal" style={{ objectPosition: 'center 30%' }} />
            </div>
            <div className="pc-info">
              <div className="pc-name">{principal.name}</div>
              <div className="pc-role">{principal.role} · St. Xavier's EMS, Guledgudd</div>
            </div>
          </div>
          <div className="pm reveal" ref={msgRef}>
            <div className="pm-quote">"</div>
            {principal.message.map((para, i) => <p key={i}>{para}</p>)}
            <div className="pm-sig">
              <strong>{principal.name}</strong>
              <span>{principal.role}, St. Xavier's English Medium School, Guledgudd</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
